import { render, staticRenderFns } from "./TextToast.vue?vue&type=template&id=50b36140&scoped=true&"
import script from "./TextToast.vue?vue&type=script&lang=ts&"
export * from "./TextToast.vue?vue&type=script&lang=ts&"
import style0 from "./TextToast.vue?vue&type=style&index=0&id=50b36140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b36140",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
